import Typical from "react-typical";
import "./about.css";

export default function About() {
  return (
    <div className="about" id="about">
      <div className="aboutTitle">
        <h2 className="titleHead">About me</h2>
        <p className="titleDoc">who i am</p>
      </div>
      <div className="aboutDetails">
        <div className="aboutPhoto" data-aos="fade-up">
          <img src="images/Asadulla.jpg" alt="Asadulla" />
        </div>
        <div className="aboutInfo" data-aos="fade-down">
          <h4>
            This is Asadulla and I'm a{" "}
            <Typical
              steps={[
                "Full Stack Developer",
                1500,
                "Frontend Web Developer",
                1500,
                "Backend Web Developer",
                1500,
                "Web Designer",
                1500,
                "MERN Stack Developer",
                1500,
              ]}
              loop={Infinity}
              wrapper="span"
            />
          </h4>
          <p>
            I'm a Professional Web Developer from Dhaka, Bangladesh with around
            5 years of experience. I specialize in MERN stack and have expertise
            in building both static and dynamic websites. Skilled in developing
            web applications using{" "}
            <strong>
              React, Node.js, Express, Laravel, MongoDB, and MySQL
            </strong>
            , I've worked with startups and small businesses to create
            functional, beautiful websites. Coding is my passion and continuous
            learning is my hobby. Client satisfaction is my dream.
          </p>
          <a
            href="asadulla.pdf"
            rel="noreferrer"
            target="_blank"
            download={"Asadulla Ahmed.pdf"}
            className="link buttonWrapper"
          >
            <button className="button">Download CV</button>
          </a>
        </div>
      </div>
    </div>
  );
}
